(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-current-date-draws.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-current-date-draws.js');
"use strict";


const {
  useContext,
  useRef
} = React;
const {
  DrawState,
  getDrawStateEnum,
  drawStateEnums
} = svs.components.sport.tipsenShared;
const {
  EngineProviderContext
} = svs.components.tipsen.engine;
const tipsenApi = svs.components.tipsen.store.tipsenApi;

const getLatestDateObjByStateOrder = resultDates => {
  let latestResults = resultDates.filter(resultDate => getDrawStateEnum(resultDate.drawStateId) === drawStateEnums.LIVE);

  if (latestResults.length === 0) {
    latestResults = resultDates.filter(resultDate => resultDate.drawStateId === DrawState.Finalized);
  }

  if (latestResults.length === 0) {
    latestResults = resultDates;
  }
  return latestResults.length > 0 ? new Date(latestResults[latestResults.length - 1].date) : null;
};
const filterDrawsOnSpecifiedDate = (resultDates, specifiedDate) => resultDates.filter(resultDate => dateFns.isSameDay(new Date(resultDate.date), specifiedDate));

const useCurrentDateDraws = (year, month, currentDate, hasDateParam) => {
  var _dateResult$current;
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const dateResult = useRef();
  const {
    data,
    isLoading,
    error
  } = tipsenApi.useGetResultDatePickerQuery({
    year,
    month,
    product: currentEngine.loadDrawsApiPath
  });
  dateResult.current = data;
  let specifiedDateDraws = [];
  let latestDateObj = null;
  const fetchedDates = (data === null || data === void 0 ? void 0 : data.resultDates) || [];
  if ((_dateResult$current = dateResult.current) !== null && _dateResult$current !== void 0 && _dateResult$current.resultDates) {
    const resultDates = dateResult.current.resultDates;
    latestDateObj = getLatestDateObjByStateOrder(resultDates);
    const specifiedDate = hasDateParam ? currentDate : latestDateObj;
    specifiedDateDraws = filterDrawsOnSpecifiedDate(resultDates, specifiedDate);
  }
  return [specifiedDateDraws, isLoading, fetchedDates, latestDateObj, error];
};
setGlobal('svs.components.tipsen.routeResult.useCurrentDateDraws', useCurrentDateDraws);

 })(window);